<template>
  <div class="modal fade"  id="modalEditarCategoria" tabindex ="-1"
    role="dialog" aria-labelledby="modalEdigarCategoriaLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="AgregarCategoriasModal">Agregar Categorias y Subcategorias</h5>
          <button type ="button" class="close" @click="cerrarModal">
            <span aria-hidden="true">&times;</span>
          </button>          
        </div>        
        <div class="modal-body">
          <!------------------CUERPO DEL MODAL------------------------------>
          <div class="row mt-3 px-3">            
            <div class="text-center rounded border border-success pt-2 col-12 col-md-12"  >
              <h5> 
                <i class="fa fa-user fa-lg text-success"></i>                
                {{ pickeador.username }}
              </h5>            
            </div> 
            <div class="col-6 col-md-6 text-left mt-3">
              <label class="text-left">Fecha de Inicio</label>
              <input type="date" class="form-control"  v-model = "current.fecha_inicio">
            </div>
            <div class="col-6 col-md-6 text-left mt-3">
              <label>Fecha Fin</label>
              <input  type="date" class="form-control" v-model = "current.fecha_fin">                          
            </div>
            <div class="col-6 col-md-6 text-left mt-3">
              <label class="text-left">Tienda origen </label>
              <select :disabled="current.estatus == false" class="form-control" v-model="current.tienda_origen">
                <option v-for="(tienda, key) in tiendas" :value="tienda.codigo" :key="key">
                  {{ tienda.codigo }} - {{ tienda.nombre }}
                </option>
              </select>
            </div>          
            <div class="col-6 col-md-6 text-left mt-3">
              <label class="text-left">Tienda destino </label>
              <select :disabled="current.estatus == false" class="form-control" v-model="current.tienda_destino">
                <option v-for="(tienda, key) in tiendas" :value="tienda.codigo" :key="key">
                  {{ tienda.codigo }} - {{ tienda.nombre }}
                </option>
              </select>
            </div>    
            <div class="col-12 col-md-6 text-left mt-1">
              <label>Tipo Tarea</label>
                <select
                  label="tarea_tipo"
                  v-model="current.tarea_tipo"
                  class="form-control px-0 py-0"
                  :filterable="false"                            
                  >
                  <option v-for="(t, key) in tarea_tipo"
                    :value="t.id"
                    :key="key"
                  >
                    {{ t.nombre }}
                  </option>
                </select>
            </div>
            <div class="col-6 col-md-6 text-left mt-1">
              <ProveedoresSelectComponent :disabled="false" :current="current" :key="componenteKey"/>
            </div>
            <div class="col-6 col-md-6 text-left">
              <label>Categoria</label> 
              <CategoriaSelectComponent v-show="mostrarCategoria" :disabled="false" :current="current" 
                title="hide" :key="componenteKey"/>               
            </div> 
            <div class="col-12 col-md-6 text-left">
              <label>Sub Categoria</label>
              <SubCategoriaSelectComponent v-show="mostrarSubCategoria" :disabled="false" :current="current" 
                title="hide" :key="componenteKey"/>       
            </div>   
          </div>

        </div>
        <div class="modal-footer mx-3 px-6">          
          <button type="button" class="btn btn-success btn-block" @click="guardar(current)">
            <i class="fa fa-save"></i>    
            Guardar
          </button>
          <button type=" button" class="btn btn-danger" @click="darDeBaja(current)" v-if="existeRegistro">
            <i class="fa fa-power-off"></i>
            Dar de baja
          </button>
          <button type=" button" class="btn btn-dark" @click="cerrarModal()" v-if="!existeRegistro">           
            Cancelar
          </button> 
        </div>
      </div>
    </div>  
  </div>

</template>

<script>
  import TiendaSelectComponent from "@/components/commons/TiendaSelectComponent";
  import CategoriaSelectComponent from "@/components/commons/CategoriaSelectComponent ";
  import SubCategoriaSelectComponent  from "@/components/commons/SubCategoriaSelectComponent ";
  import ProveedoresSelectComponent from "@/components/commons/ProveedoresSelectComponent";
  import DynamicService from "../../../../services/commons/DynamicService";
  import Notifications from "@/notifications/notifications";
  import moment from "moment";

  export default{
    props: {
      pickeador:{
        type: Object,
        required: true,
        default: null, 
      } ,
      registroCategoria:{
        type: Object,
        required: false,
        default: null
      }
    
    },
    components:{
      TiendaSelectComponent,
      CategoriaSelectComponent,
      SubCategoriaSelectComponent,      
      ProveedoresSelectComponent,  
    },
    data(){
      return{
        current:{
          tienda_origen: null,
          tienda_destino: null,
          categoria: "",
          subcategoria:"",
          tarea_tipo: ""
        },  
        tarea_tipo:[],
        mostrarCategoria:true,
        mostrarSubCategoria:true,
        mostrarModal: false, 
        existeRegistro: false,
        keyTiendaOrigen: 0,
        tiendas:[],
        subcategorias:[],
        lastFieldTouched: "",
        id_cat:"",
        componenteKey:0
      }
    },
    watch:{
      pickeador(val){        
        if(val && val.id){
          this.current.pickeador = val.id
        }
      },
      "current.categoria"(val){   
        setTimeout(()=>{                
          if(!val || !this.current.subcategoria){  
            return
          }               
          if(this.lastFieldTouched ==="subcategoria"){              
            return
          }
          Notifications.alert.error("Acción inválida",
          "Solo puede seleccionar una categoria **o** una subcategoría")
          //Se limpia current y se limpia input
          this.current.categoria=""       
          //se fuerza a renderizar input para mostrar vacío
          this.mostrarCategoria = false;
          this.$nextTick(()=> {
          this.mostrarCategoria= true
          });
        },0)
   
      },    
      
      "current.subcategoria"(val){   
        setTimeout(()=>{         
          //Se verifica si si hay valor en select actual y si hay en el de categegoria       
          if(!val || !this.current.categoria){  
            return
          }  
          if(this.lastFieldTouched ==="categoria"){         
            return;            
          }       
        
          Notifications.alert.error("Acción inválida",
          "Solo puede seleccionar una categoria **o** una subcategoría")         

          this.current.subcategoria=""       
          //se fuerza a renderizar input para mostrar vacío
          this.mostrarSubCategoria = false;
          this.$nextTick(()=> {
            this.mostrarSubCategoria= true
          }); 
        }, 0);
                 
      }, 
      "current.tienda_origen"(val){     
          if(val !==undefined && this.current.tienda_destino == val){
            Notifications.alert.error("Accion invalida", "La tienda de origen y destino no pueden ser iguales")
            this.current.tienda_origen = "";
          }
     
      },
      "current.tienda_destino"(val){    
          if(val !==undefined && this.current.tienda_origen == val){
            Notifications.alert.error("Accion invalida", "La tienda de origen y destino no pueden ser iguales")
            this.current.tienda_destino = "";
          }
      }, 
      "current.proveedor"(val){
        if(!val){                    
          this.current.proveedor = ""
        } 
      },
      registroCategoria(val){     
        if(val){     
          this.obtenerDatos()
        }else{
          //se limpia currentc   
          this.current={}   
        }        
      }
    }, 
    mounted(){
      let self = this;
      self.obtenerTipoTareas();
      self.refresh() //para limpiar datos
      self.refreshTienda()       
    },
    methods:{
      obtenerTipoTareas(){
        let self= this;
        let params = {
          quitar_paginacion: true,
        }
        DynamicService.fetch("wms","tarea-tipo",params).then((response)=>{          
          self.tarea_tipo =response.data;
        })
      },   
      guardar(current){
        let self= this;  
        if(self.validacionesGuardar()&& self.existeRegistro){          
          //Si las validaciones son correctas y existe registro, es para modificar...     
          self.current.categoria = self.current.categoria.codigo
          self.current.sub_categoria = self.current.subcategoria.codigo
          self.current.proveedor = self.current.proveedor.codigo    
      
          DynamicService.postAction(
            "wms", 
            "asignar-tarea-usuario", 
            self.id_cat, 
            "actualizar_datos_categoria", 
            self.current)
          .then((response) => {                
            Notifications.alert.success(
              "Agregar nueva asignación de usuario y tarea",
              "Agregado existosamente"
            );        
            self.cerrarModal()           
            self.$emit('refresh')
          }) 
          .catch((error) =>{
            Notifications.alert.error("Error", error)
          })     
        }else if(self.validacionesGuardar() &&!self.existeRegistro){    
          self.current.categoria = self.current.categoria.codigo
          self.current.sub_categoria = self.current.subcategoria.codigo
          self.current.proveedor = self.current.proveedor.codigo      
          DynamicService.save("wms", "asignar-tarea-usuario", self.current)
          .then((response) => {           
            Notifications.alert.success(
              "Agregar Categorias y subcategorias a usuario",
              "Agregado existosamente"
            );
            self.cerrarModal()
            self.$emit('refresh')
          });       
        }

      },
      validacionesGuardar(){
        //Hace validaciones correspondicentes para guardar datos correctos
        let self = this;  
        //Validaciones si fecha de inicio es menor a la fecha de fin
        if(self.current.fecha_inicio > self.current.fecha_fin){
          Notifications.alert.error("Fechas invalidas","La fecha de inicio debe ser menor a la fecha de fin");
          return false;        
        }   
        //validaciones de tiendas
        if((self.current.tienda_origen !== "" && self.current.tienda_destino !=="")
          && (self.current.tienda_origen ===self.current.tienda_destino)){
            Notifications.alert.error("Accion invalida", "La tienda de origen y destino no pueden ser iguales")
            return false;
        }      
        
        if(!self.current.tarea_tipo){
          self.current.tarea_tipo = ""
        }

        // Validaciones: campos obligatorios llenos
        if(self.current.fecha_inicio == "" 
            || self.current.fecha_fin == "" 
            || self.current.tarea_tipo == ""
            || self.current.tienda_origen == ""
            || self.current.tienda_destino ==""             
        ){
          Notifications.alert.error("Campos requeridos","Debe completar todos los campos requeridos: " +
          "[fecha inicio], [fecha fin], [tienda origen], [tienda destino], [tarea tipo], [categoria] o [sub categoria]" )
          return false
        }        
     
        //Se manejan indefinidos de categoria y subcategoria
        if(!self.current.categoria){  
          self.current.categoria = "";          
        }
        
        if(!self.current.subcategoria){     
          self.current.subcategoria = "";
        }

        // validacion si no está seleccionado una categoría o una subcategoria
        if(self.current.categoria == ""  && self.current.subcategoria == "")          
        {
          Notifications.alert.error("Campos requeridos ", "Debe seleccionar categoria **o** una sub categoria")
          return false
        }
      
        //validacion si hay categoria y subcategoria seleccionada
        if(self.current.categoria  && self.current.subcategoria){
          Notifications.alert.error("Accion invalida", "Solo puede seleccionar una categoria **o** sub categoria")
          return false
        }     
         //formateando fechas 
        if(self.current.fecha_inicio){
          self.current.fecha_inicio = moment(self.current.fecha_inicio).format('YYYY-MM-DDTHH:mm:ss')          
        }    
        if(self.current.fecha_fin){       
          self.current.fecha_fin = moment(self.current.fecha_fin).format('YYYY-MM-DDTHH:mm:ss')           
        }

        self.current.estatus =  true

        //validaciones de proveedor
        if(!self.current.proveedor){
          self.current.proveedor = ""
        }    
        self.current.pickeador = self.pickeador.id
        return true;
      },
      refresh(){
        let self=this;  
        self.current = {} 
        self.componenteKey++ 
      },

      limpiarCategorias(){
        let self = this;
        self.current.categoria=""
        self.categoria={} 
        self.current.sub_categoria=""
        self.sub_categoria={}
        self.mostrarCategoria =false
        
        self.$nextTick(()=>{
          self.mostrarCategoria = true
        })
      },
      obtenerDatos(){        
        let self=this;   
        self.id_cat = self.registroCategoria.id
        self.existeRegistro= true 
        const cleanRegistro = {...self.registroCategoria}  
    
        cleanRegistro.subcategoria = cleanRegistro.sub_categoria    
        delete cleanRegistro.sub_categoria
        self.current = cleanRegistro;   
        self.current.fecha_inicio=moment(self.registroCategoria.fecha_inicio).format('YYYY-MM-DD'),
        self.current.fecha_fin=moment(self.registroCategoria.fecha_fin).format('YYYY-MM-DD')  
      },
      cerrarModal(){        
        let self=this;
        self.refresh()     
        self.existeRegistro= false
        self.$emit("cerrarModal")        
      },
      refreshTienda() {
        let self = this;
        DynamicService.fetch("cat", "tiendas", {
          quitar_paginacion: true,
        }).then((response) => {
          self.tiendas = response.data;
        });
      },
      darDeBaja(categoria){
        let self = this       
        Notifications.alert.confirm(
        "Dar de baja",
        "¿Desea dar de baja la categoria/subcategoría?",
        "",
        function () {
          DynamicService.postAction(
            "wms",
            "asignar-tarea-usuario",
            categoria.id,
            "dar_de_baja"
          )
          .then((response) => {            
            Notifications.alert.success(
              "Dar de Baja",
              "Realizado Exitosamente"
            );          
            self.refresh();
            self.$emit("refresh")
          })
          .catch((error) => {
            Notifications.alert.error(
              "Error al dar de baja",
              error
            );
          });
          self.cerrarModal();
          }
        );
      },    

    }
    
      
  }

</script>

<style>

</style>